import React from 'react';

export default function Time({ time, senderType }) {
  return (
    <span
      className={`text-xs text-gray-300 block mt-1 ${
        senderType === 'user' ? 'text-right ml-3' : 'text-left mr-3'
      }`}
    >
      {time}
    </span>
  );
}
